<ion-grid>
  <ion-row>
    <ion-col>
      <h1>Tax Info</h1>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <gc-tax-info-form
        [validated]="validated"
        [form]="form"
        [user]="user"
        [files]="files"
        (fileAdded)="fileAdded.emit($event)"
      ></gc-tax-info-form>
    </ion-col>
  </ion-row>
</ion-grid>
